import GradeLessonPage from '../components/GradeLessonPage';
import { kindergartenTopics } from './data';

export default function KindergartenPage() {
  return (
    <GradeLessonPage
      grade="K"
      gradeLabel="Kindergarten"
      gradeColor="orange"
      topics={kindergartenTopics}
      nextGrade={{ label: 'Grade 1', path: '/grade/1' }}
    />
  );
}
